import React from "react";
import { APERTURE } from "../../lib/aperture";

// The brand mark, rendered from shared geometry. `decorative` hides it from
// assistive tech (use when adjacent text already names the brand); otherwise it
// exposes an accessible label.
export default function ApertureMark({
  className = "",
  strokeWidth = 29,
  decorative = false,
  title = "Digital Philosophy",
  ...rest
}) {
  const a11y = decorative
    ? { "aria-hidden": true, focusable: "false" }
    : { role: "img", "aria-label": title };

  return (
    <svg
      className={`dp-mark ${className}`.trim()}
      viewBox={APERTURE.viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
      {...a11y}
      {...rest}
    >
      {APERTURE.rings.map((c, i) => (
        <circle key={`ring-${i}`} cx={c.cx} cy={c.cy} r={c.r} />
      ))}
      {APERTURE.bars.map((b, i) => (
        <line key={`bar-${i}`} x1={b.x} y1={b.y1} x2={b.x} y2={b.y2} />
      ))}
    </svg>
  );
}
